<template>
    <footer class="frontend-style">
        <div class="textBox">
            <ul class="first">
                <li><h4>{{$t('Footer.productTitle')}}</h4></li>
                <li
                    class="cursorPoint"
                    v-for="item in CataNowList"
                    v-html="item[locales]"
                    @click="goPage({path:'/products'},{name:item[locales],cateId:item.id})"
                />
            </ul>
            <ul class="second">
                <li><h4>{{$t('Footer.contactTitle.title')}}</h4></li>
                <li>{{$t('Footer.contactTitle.other.email')}}info@soonport.com</li>
                <li>{{$t('Footer.contactTitle.other.phone')}}+886-5-238-0959</li>
                <li>{{$t('Footer.contactTitle.other.address')}}</li>
                <li v-if="windowWidth>1112" @click="goPage({path:'/login'})" class="goSystem cursorPoint">{{$t('Footer.contactTitle.other.system')}}</li>
            </ul>
            <ul class="third">
                <li>
                    <GMap
                    />
                </li>
                <li>{{$t('Footer.contactTitle.other.hours')}} 8:00 AM - 5:00 PM, Mon. ~ Sat.</li>
               
            </ul>
            <div class="copyright">
                copyright © SOONPORT 2020  Designed by Glave & Glove
            </div>
        </div>
    </footer>
</template>
<script>
import{mapState, mapActions, mapGetters}from 'vuex'
export default {
    name:'Footer',
    computed:{
        ...mapState('frontend',[
            'categories',
            'locales',
            'windowWidth'
        ]),
        ...mapGetters('frontend',[
            'CataNowList'
        ])
    },
    data() {
        return {
            pages:[
                {title:'Products',path:'/products'},
                {title:'Quality Control',path:'/quality'},
                {title:'Manufacture',path:'/manufacture'},
                {title:'About',path:'/about'},
                {title:'Contact',pop:'contact'}
            ]
        }
    },
    methods: {
        ...mapActions('frontend',['changeCategory']),
        categorySwitch(name,id){
				const payload={name:name,id:id}
				this.changeCategory(payload)
		},
        goPage(link,query){
            query?this.categorySwitch(query.name,query.cateId):false

            link.path?
            this.$router.push({path:link.path}):
            this.$router.replace({query:{Popup:link.pop}})
        }
    },
}
</script>
